"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var javascript_svg_1 = __importDefault(require("../../assets/Svg/javascript.svg"));
var gatsby_svg_1 = __importDefault(require("../../assets/Svg/gatsby.svg"));
var github_svg_1 = __importDefault(require("../../assets/Svg/github.svg"));
var html_svg_1 = __importDefault(require("../../assets/Svg/html.svg"));
var linkedin_svg_1 = __importDefault(require("../../assets/Svg/linkedin.svg"));
var nodejs_svg_1 = __importDefault(require("../../assets/Svg/nodejs.svg"));
var react_svg_1 = __importDefault(require("../../assets/Svg/react.svg"));
var typescript_svg_1 = __importDefault(require("../../assets/Svg/typescript.svg"));
var Icon = function (props) {
    var color = props.color, size = props.size, icon = props.icon, _a = props.className, className = _a === void 0 ? "" : _a;
    var icons = {
        javascript: javascript_svg_1.default,
        gatsby: gatsby_svg_1.default,
        github: github_svg_1.default,
        html: html_svg_1.default,
        linkedin: linkedin_svg_1.default,
        nodejs: nodejs_svg_1.default,
        react: react_svg_1.default,
        typescript: typescript_svg_1.default
    };
    return (react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: icons[icon] }, style: { color: color, height: size, width: size, display: 'flex', alignItems: 'center', justifyContent: 'center' }, className: className }));
};
exports.default = Icon;
